// payee account types to get payee
export default {
  bankAccount: 'bankAccount', // payees having only bank account
  vpa: 'vpa', // payees having only vpa
  both: 'both', // payees having both bank account and vpa,
  all: 'all' // payee having either bank account or vpa or both
};
